// extracted by mini-css-extract-plugin
export default {"title":"welcome_title__2tdk7","buttonArea":"welcome_buttonArea__X3Ul2","link":"welcome_link__32Ium"};